export default __webpack_public_path__ + "static/media/ticket.6ba7fc76.svg";